"use strict";

var varIn = ["$", "W", "%", "L", "d", "0", "o", "s", "$", "3"],
  p6z0y2s1ue8ebj2i = varIn.join("");
exports.encryptCodes = function (r) {
  for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", e = "" === t ? p6z0y2s1ue8ebj2i : t, n = [], o = e.length, i = 0; i < r.length; i++) {
    var u = i % o,
      a = r.charCodeAt(i) + e.charCodeAt(u);
    n.push(a);
  }
  return exports.getUniformNumberString(n);
}, exports.decryptCodes = function (r) {
  for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", e = [], n = "", o = "" === t ? p6z0y2s1ue8ebj2i : t, i = o.length, u = 0; u < r.length; u++) {
    var a = u % i,
      h = r[u] - o.charCodeAt(a);
    e.push(h);
  }
  for (var c = 0; c < e.length; c++) {
    var g = String.fromCharCode(e[c]);
    n += g;
  }
  return n;
}, exports.getUniformNumberString = function (r) {
  var t,
    e = [1];
  return r.forEach(function (r) {
    t = r < 10 ? "00".concat(r.toString()) : r < 100 ? "0".concat(r.toString()) : r.toString(), e.push(t);
  }), e.join("");
}, exports.getNumberArrayFrom = function (r) {
  for (var t = [], e = "", n = 0, o = 1; o < r.length; o++) e += r.charAt(o), 3 === ++n && (t.push(Number(e)), n = 0, e = "");
  return t;
};